import { Component, computed, inject, input, output, ViewChild } from '@angular/core';

import { ServiceUploadCertificateComponent } from '../service-upload-certificate/service-upload-certificate.component';
import { routeParams, translate } from '../../../../../modules/shared/shared.global-service';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import { TableColumn, TableColumnType } from '../../../../../modules/shared/components/kit/table/table.types';
import { ServiceCertificateObject } from '@libs/types/src/services/object-type/service/service-certificate.object';
import { validFromColumn, validToColumn } from '../../../../../modules/shared/components/kit/table/table.fields';
import { ServiceCertificatesSettingsStore } from './service-certificates-settings.store';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { ConfirmBuilder } from '../../../../../modules/shared/service/confirm.builder';
import { FilterInput } from '@it2go/data-grid';
import {
    ServiceUploadCertificateModalComponent,
} from '../service-upload-certificate-modal/service-upload-certificate-modal.component';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../../modules/shared/components/kit/table/card-table.component';

@Component({
    selector: 'app-service-certificates-settings',
    imports: [
        CardTableComponent,
    ],
    templateUrl: './service-certificates-settings.component.html',
    styleUrl: './service-certificates-settings.component.scss',
    providers: [ServiceCertificatesSettingsStore],
})
export class ServiceCertificatesSettingsComponent {
    public readonly store = inject(ServiceCertificatesSettingsStore);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly dialogService = inject(BaseDialogService);

    public serviceId = input<number>(0);
    public title = input('service.settings.sick-notes.suklCertificatesTitle');
    public changed = output<void>();

    @ViewChild(ServiceUploadCertificateComponent)
    serviceUploadCertificateComponent!: ServiceUploadCertificateComponent;
    @ViewChild('suklCertificatesTable') private tableRef!: TableComponent;

    protected columns: TableColumn[] = [
        { name: 'id' },
        {
            name: 'valid',
            dataKey: null,
            data: (item: ServiceCertificateObject) => {
                const dateNow = new Date();
                const validFrom = item.validFrom
                    ? new Date(item.validFrom)
                    : null;
                const validTo = item.validTo ? new Date(item.validTo) : null;

                return validFrom && validTo
                    ? validFrom <= dateNow && validTo >= dateNow
                    : false;
            },
            type: TableColumnType.Active,
        },
        validFromColumn,
        validToColumn,
    ];

    protected additionalFilters = computed<FilterInput[][]>(() => [
        [
            {
                column: 'serviceId',
                operator: 'eq',
                value: [String(this.serviceId() || 0)],
            },
        ],
    ]);

    async save() {
        await this.serviceUploadCertificateComponent.save();
    }

    async refresh() {
        await this.tableRef.reload();
        this.changed.emit();
    }

    addCertificate() {
        const ref = this.dialogService.open(
            ServiceUploadCertificateModalComponent,
            {
                header: translate.instant(
                    'service.settings.sick-notes.addCertificate',
                ),
                data: {
                    serviceId: this.serviceId(),
                },
                styleClass: 'p-dialog-width-60',
            },
        );
        ref.onClose.subscribe(async (result) => {
            if (result) {
                this.refresh();
            }
        });
    }

    protected async deleteCertificate(event: any) {
        this.confirm.confirmDelete(async () => {
            await this.store.api.deleteServiceCertificate({
                id: event.item.id,
            });
            this.refresh();
            contentGlobalSuccess.next('common.deleted');
        }, event);
    }

    protected readonly routeParams = routeParams;
    protected readonly Number = Number;
}
